import React, { useEffect, Fragment, useState } from "react"
import { withRouter } from "react-router"
import { useDispatch } from "react-redux"
import { Box, CircularProgress } from "@material-ui/core"
import { MuiThemeProvider } from "@material-ui/core/styles"
import billingTheme from "../../../themes/billing"
import CrewMamaAppBarComponent from "../../../components/CrewmamaAppBar/index"
import ActionBarComponent from "../../../components/ActionBar/index"
import LoadingButton from "../../../components/LoadingButton/index"
import { getExpensesTypesList } from "../../../actions/billing"
import { toggleManageExpensesDialog } from "../../../actions/billingDialogs"
import { createExpenseListType } from "../../../actions/super"
import { openSnackBar } from "../../../actions/snack-bar"
import ExpensesListTable from "../../../components/Billing/SuperAdmin/ExpensesListTable/index"

const Expenses = props => {
  const dispatch = useDispatch()
  const handleBack = () => {
    props.history.push("/billing")
  }

  const [loading, setLoading] = useState(false)
  const [createLoading, setCreateLoading] = useState(false)
  const [expensesListCopy, setExpensesListCopy] = useState([])

  useEffect(() => {
    setLoading(true)
    dispatch(getExpensesTypesList())
      .then(res => {
        setExpensesListCopy(res)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        setLoading(false)
      })
  }, [])

  const createNewExpenseType = dialogVals => {
    setCreateLoading(true)
    dispatch(createExpenseListType(dialogVals))
      .then(res => {
        setCreateLoading(false)
        setExpensesListCopy(oldState => {
          return [...oldState, { ...dialogVals, id: res.data.item_id }]
        })
        dispatch(openSnackBar({ message: "Expense Type Created" }))
      })
      .catch(err => {
        console.log(err)
        setCreateLoading(false)
        dispatch(openSnackBar({ message: "Error Creating Expense Type " }))
      })
  }

  const openNewExpenseDialog = () => {
    let dialogData = {
      expenseFunc: createNewExpenseType,
    }
    dispatch(toggleManageExpensesDialog(true, dialogData))
  }

  return (
    <Fragment>
      <CrewMamaAppBarComponent history={props.history} />
      <MuiThemeProvider theme={billingTheme}>
        <ActionBarComponent
          buttonChildren={() => {
            return (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                margin={window.innerWidth < 600 ? 0 : "0 20px"}
                flexGrow={window.innerWidth < 600 ? 1 : 0}
              >
                <LoadingButton
                  variant="outlined"
                  onClick={handleBack}
                  style={
                    window.innerWidth < 600
                      ? { marginLeft: "20px" }
                      : { marginRight: "10px" }
                  }
                >
                  Back to Billing
                </LoadingButton>
                <LoadingButton
                  variant="contained"
                  color="primary"
                  style={window.innerWidth < 600 ? { marginRight: "20px" } : {}}
                  onClick={openNewExpenseDialog}
                  disabled={createLoading}
                >
                  {createLoading ? (
                    <CircularProgress
                      size={20}
                      style={{ margin: "4px 0", color: "#fff" }}
                    />
                  ) : (
                    "+ Add Item"
                  )}
                </LoadingButton>
              </Box>
            )
          }}
        />
        {loading ? (
          <CircularProgress />
        ) : (
          <ExpensesListTable
            expensesList={expensesListCopy}
            setExpensesList={setExpensesListCopy}
          />
        )}
      </MuiThemeProvider>
    </Fragment>
  )
}
export default withRouter(Expenses)
